import {
  FETCH_STOCK_ISSUES_REQUEST,
  FETCH_STOCK_ISSUES_SUCCESS,
  FETCH_STOCK_ISSUES_FAILURE,
  CREATE_STOCK_ISSUE_SUCCESS,
  MARK_STOCK_ISSUE_RECEIVED_SUCCESS,
  DELETE_STOCK_ISSUE_SUCCESS,
  FETCH_STOCK_ISSUES_BY_EMPLOYEE_SUCCESS,
  FETCH_STOCK_ISSUES_BY_BATCH_SUCCESS,
  FETCH_UNIQUE_EMPLOYEES_SUCCESS,
  FETCH_UNIQUE_BATCHES_SUCCESS,
  FETCH_STOCK_RECEIVED_REPORT_REQUEST,
  FETCH_STOCK_RECEIVED_REPORT_SUCCESS,
  FETCH_STOCK_RECEIVED_REPORT_FAILURE
} from '../../types/stockIssue/stockIssueTypes';
import * as api from '../../../api/stockIssue/stockIssueApi';

export const fetchStockIssues = (params = {}, options = {}) => async (dispatch) => {
  const append = Boolean(options.append);
  dispatch({ type: FETCH_STOCK_ISSUES_REQUEST, append });
  try {
    const { data } = await api.fetchStockIssues(params);
    dispatch({ type: FETCH_STOCK_ISSUES_SUCCESS, payload: data, append });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch stock issues';
    dispatch({ type: FETCH_STOCK_ISSUES_FAILURE, payload: errorMessage, append });
    throw error;
  }
};

export const fetchStockIssuesByEmployee = (emp_code, status = null, fromDate = null, toDate = null) => async (dispatch) => {
  dispatch({ type: FETCH_STOCK_ISSUES_REQUEST });
  try {
    const { data } = await api.fetchStockIssuesByEmployee(emp_code, status, fromDate, toDate);
    dispatch({ type: FETCH_STOCK_ISSUES_BY_EMPLOYEE_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch stock issues by employee';
    dispatch({ type: FETCH_STOCK_ISSUES_FAILURE, payload: errorMessage });
  }
};

export const fetchStockIssuesByBatch = (batch_no, status = null, fromDate = null, toDate = null) => async (dispatch) => {
  dispatch({ type: FETCH_STOCK_ISSUES_REQUEST });
  try {
    const { data } = await api.fetchStockIssuesByBatch(batch_no, status, fromDate, toDate);
    dispatch({ type: FETCH_STOCK_ISSUES_BY_BATCH_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch stock issues by batch';
    dispatch({ type: FETCH_STOCK_ISSUES_FAILURE, payload: errorMessage });
  }
};

export const fetchUniqueEmployees = (status = null) => async (dispatch) => {
  try {
    const { data } = await api.fetchUniqueEmployees(status);
    dispatch({ type: FETCH_UNIQUE_EMPLOYEES_SUCCESS, payload: data });
  } catch (error) {
    // Silently handle error for non-critical data
    dispatch({ type: FETCH_UNIQUE_EMPLOYEES_SUCCESS, payload: [] });
  }
};

export const fetchUniqueBatches = (status = null) => async (dispatch) => {
  try {
    const { data } = await api.fetchUniqueBatches(status);
    dispatch({ type: FETCH_UNIQUE_BATCHES_SUCCESS, payload: data });
  } catch (error) {
    // Silently handle error for non-critical data
    dispatch({ type: FETCH_UNIQUE_BATCHES_SUCCESS, payload: [] });
  }
};

export const createStockIssue = (issue) => async (dispatch) => {
  try {
    console.log('createStockIssue action - Input:', issue);
    const { data } = await api.createStockIssue(issue);
    console.log('createStockIssue action - Response:', data);
    dispatch({ type: CREATE_STOCK_ISSUE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    console.error('createStockIssue action - Error:', error);
    console.error('createStockIssue action - Error response:', error.response);
    throw error;
  }
};

export const markStockIssueReceived = (id, received_by) => async (dispatch) => {
  const { data } = await api.markStockIssueReceived(id, received_by);
  dispatch({ type: MARK_STOCK_ISSUE_RECEIVED_SUCCESS, payload: { id, ...data } });
};

export const deleteStockIssue = (id) => async (dispatch) => {
  await api.deleteStockIssue(id);
  dispatch({ type: DELETE_STOCK_ISSUE_SUCCESS, payload: id });
};

export const fetchStockReceivedReport = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_STOCK_RECEIVED_REPORT_REQUEST });
  try {
    const { data } = await api.fetchStockReceivedReport(filters);
    dispatch({ type: FETCH_STOCK_RECEIVED_REPORT_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch stock received report';
    dispatch({ type: FETCH_STOCK_RECEIVED_REPORT_FAILURE, payload: errorMessage });
  }
};

export const fetchStockIssuesForReceive = (status = 'issued', fromDate = null, toDate = null) => async (dispatch) => {
  console.log('Redux Action: fetchStockIssuesForReceive called with:', { status, fromDate, toDate });
  dispatch({ type: FETCH_STOCK_ISSUES_REQUEST });
  try {
    console.log('Redux Action: Making API call to fetchStockIssuesForReceive');
    const { data } = await api.fetchStockIssuesForReceive(status, fromDate, toDate);
    console.log('Redux Action: API call successful, data received:', data?.length || 0, 'records');
    dispatch({ type: FETCH_STOCK_ISSUES_SUCCESS, payload: data });
  } catch (error) {
    console.error('Redux Action: API call failed:', error);
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch stock issues for receive';
    dispatch({ type: FETCH_STOCK_ISSUES_FAILURE, payload: errorMessage });
  }
}; 